import { Component } from 'vue'
export enum ERowTypes {
    COMPONENT = 'component',
    HIDDEN = 'hidden',
    HTML = 'html',
}
declare type UiLabelsGroupType = {
    labels: string[]
    asString?: boolean
    labelClick?: (index: number) => void
    customLabelClass?: string
    customWrapperClass?: string
}
export type CustomCell = {
    type: ERowTypes
    html?: string
    data?: { id?: number; status?: string; type?: string }
    component?: Component
    componentConfig?: UiLabelsGroupType
}

export type TableBody = string | number | null | CustomCell
export interface ITableData<TBody = TableBody> {
    head: string[]
    body: TBody[][]
}
